import { useState }                                              from "react";

// Foto do jogador ou da crew. Se a URL falhar (foto do Roblox expirada, CDN fora), cai no logo.
const RESERVA = "/web-app-manifest-192x192.png";

export default function Avatar({ src, alt = "", className = "", style }) {
  const [falhou, set_falhou] = useState(null);
  const usar = (src && src !== falhou) ? src : RESERVA;

  return (
    <img
      src={usar}
      alt={alt}
      loading="lazy"
      onError={() => (usar !== RESERVA) && set_falhou(src)}
      className={className}
      style={style}
    />
  );
}
